import React from 'react';

export default function VegaCopyBlocks() {
  return (
    <section className="px-6 lg:px-10" style={{ paddingBottom: '6rem' }}>
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '3rem',
          borderTop: '1px solid var(--line-soft)',
          paddingTop: '4rem',
        }}
      >
        <div>
          <div className="vd-eyebrow" style={{ marginBottom: '0.75rem' }}>For business</div>
          <h3 className="vd-font-display vd-ink" style={{ fontSize: '1.5rem', marginBottom: '0.75rem' }}>
            Adoption without the drag.
          </h3>
          <p className="vd-ink-soft" style={{ fontSize: '0.9375rem', lineHeight: 1.7 }}>
            Curate the software your business actually runs. Pay only for what you use. Skip the
            parasitic costs of training, certifications, and bespoke ops on someone else's stack.
            Get expertly-implemented, day-one capabilities — without growing a platform team.
          </p>
        </div>

        <div>
          <div className="vd-eyebrow" style={{ marginBottom: '0.75rem' }}>For developers</div>
          <h3 className="vd-font-display vd-ink" style={{ fontSize: '1.5rem', marginBottom: '0.75rem' }}>
            Ship without owning hosting.
          </h3>
          <p className="vd-ink-soft" style={{ fontSize: '0.9375rem', lineHeight: 1.7 }}>
            Showcase your best work. Monetize your innovations. Let Vega handle delivery,
            updates, and the helpdesk plumbing — so the only thing you maintain is the code that
            makes your software remarkable.
          </p>
        </div>
      </div>
    </section>
  );
}
